<div class="menu-container">
  <dx-menu class="left-menu" (onItemClick)="onLeftMenuItemClick($event)">
    <dxi-item> <ng-template dxTemplate="item"> <img [src]="'../../../../../assets/Hayrick/logo/'+subdomain+'/logo-dark.svg'" alt="Logo" height="60px" class="menu-logo" /> </ng-template> </dxi-item>
    <dxi-item *ngFor="let itm of items">
      <ng-template dxTemplate="itm">
        <ng-container *ngIf="itm.label !== 'Recent History' && itm.label !== 'Legal Entities'">
          <span class="header-menu-content-left">{{itm.label}}</span>
        </ng-container>
        <span *ngIf="itm.label === 'Legal Entities'" class="header-menu-content-left">{{itm.label}}</span>

        <span *ngIf="itm.label === 'Recent History'" class="header-menu-content-left"><dx-button text="" stylingMode="text" class="custom-icon" type="normal" icon="clock" hint="Recent legal entities" (onClick)="showLegalEntityHistory()"></dx-button></span>
      </ng-template>
    </dxi-item>
  </dx-menu>
  <dx-menu class="middle-menu">
    <dxi-item>
      <ng-template dxTemplate="item">
        <span class="toolbar-le-name" [attr.title]="chosenLegalEntity || null">{{ chosenLegalEntity }}</span>
      </ng-template>
    </dxi-item>
  </dx-menu>
  <dx-menu class="right-menu" [rtlEnabled]="true">

    <dxi-item>
      <ng-template dxTemplate="itm">

        <span>
          <dx-button
              text=""
              stylingMode="text"
              class="custom-icon"
              type="normal"
              icon="find"
              hint="Global search"
              (onClick)="toGlobalSearch()">
          </dx-button>
        </span>
      </ng-template>
    </dxi-item>
    <dxi-item>
      <ng-template dxTemplate="itm">
        <span *appCheckPermission="null; permissions: ['settings.view','settings.edit']; requireLegalEntityContext: false">
          <dx-button
              text=""
              stylingMode="text"
              class="custom-icon"
              type="normal"
              icon="preferences"
              hint="Settings"
              (onClick)="toSettings()">
          </dx-button>
        </span>
      </ng-template>
    </dxi-item>
    <dxi-item>
      <ng-template dxTemplate="item">
        <div
          *ngIf="roles$ | async as role; else loadingRole"
          [ngClass]="{
            'permission-status-container': !hasSettingsPermission,
            'permission-status-container-180': hasSettingsPermission
          }"
        >
          <div *ngIf="role.role !== null; else nullRole" style="margin-top: -10px;">
            <p class="permission-status-text-1">:Logged in as</p>
            <p class="permission-status-text-2">{{ userMobile }}</p>
            <p class="permission-status-text-2">{{ role.role }}</p>
          </div>
          <ng-template #nullRole>
            <div class="permission-status-null-role-container">
              <p class="permission-status-text-1">:Logged in as</p>
              <p class="permission-status-text-2">{{ userMobile }}</p>
            </div>
          </ng-template>
        </div>
        <ng-template #loadingRole>
          <dx-button
            text="loading...."
            stylingMode="text"
            type="normal">
          </dx-button>

        </ng-template>
      </ng-template>
    </dxi-item>
  </dx-menu>
  <dx-menu (onItemClick)="onRightMenuItemClick($event)">
    <dxi-item text="" icon="user" class="custom-user-item">
      <dxi-item text="Logout"></dxi-item>
    </dxi-item>
  </dx-menu>

  <button type="button" class="hamburger-toggle" aria-label="Toggle menu" (click)="mobileMenuOpen = !mobileMenuOpen">
    <i class="dx-icon dx-icon-menu"></i>
  </button>
</div>

<div class="mobile-menu-panel" *ngIf="mobileMenuOpen">
  <ng-container *ngFor="let itm of items">
    <button *ngIf="itm.label === 'Legal Entities'" type="button" class="mobile-menu-item" (click)="searchLegalEntities(); mobileMenuOpen = false">
      {{ itm.label }}
    </button>
    <button *ngIf="itm.label === 'Recent History'" type="button" class="mobile-menu-item" (click)="showLegalEntityHistory(); mobileMenuOpen = false">
      {{ itm.label }}
    </button>
    <button *ngIf="itm.label !== 'Legal Entities' && itm.label !== 'Recent History'" type="button" class="mobile-menu-item" (click)="itm.command && itm.command(); mobileMenuOpen = false">
      {{ itm.label }}
    </button>
  </ng-container>

  <button type="button" class="mobile-menu-item" (click)="toGlobalSearch(); mobileMenuOpen = false">
    Global search
  </button>

  <button
    *appCheckPermission="null; permissions: ['settings.view','settings.edit']; requireLegalEntityContext: false"
    type="button"
    class="mobile-menu-item"
    (click)="toSettings(); mobileMenuOpen = false">
    Settings
  </button>

  <div class="mobile-menu-item mobile-menu-role" *ngIf="roles$ | async as role">
    <span class="mobile-menu-role-label">Logged in as</span>
    <span class="mobile-menu-role-value">{{ userMobile }}</span>
    <span class="mobile-menu-role-value" *ngIf="role.role">{{ role.role }}</span>
  </div>

  <button type="button" class="mobile-menu-item mobile-menu-logout" (click)="logout(); mobileMenuOpen = false">
    Logout
  </button>
</div>

<div class="breadcrumb-container">

  <app-dx-breadcrumb class="breadcrumb"></app-dx-breadcrumb>
</div>

<div class="space"></div>


<dx-popup [(visible)]="legalEntitiesDisplay" [width]="800" [height]="'auto'" [maxHeight]="'80vh'"
  [showTitle]="true"
  [showCloseButton]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  titleTemplate="title">
  <div *dxTemplate="let data of 'title'" class="dx-popup-header popup-title-row">
    <h2>Select/Add legal entity</h2>
    <i class="dx-icon-close popup-close-icon" aria-hidden="true" (click)="hideSearchLegalEntitiesPopup()"></i>
  </div>
  <div *dxTemplate="let data of 'content'" class="legal-entities-popup-content">
     <app-search-legal-entities
      (closePopupEvent)="hideSearchLegalEntitiesPopup()">
      </app-search-legal-entities>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="legalEntityHistoryDisplay"
  [width]="400"
  [maxHeight]="600"
  [showTitle]="true"
  [showCloseButton]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  (onShown)="onHistoryPopupShown()"
  titleTemplate="title">
  <div *dxTemplate="let data of 'title'" class="dx-popup-header popup-title-row">
    <h2>Recent Legal Entities</h2>
    <i class="dx-icon-close popup-close-icon" aria-hidden="true" (click)="hideLegalEntityHistoryPopup()"></i>
  </div>
  <div *dxTemplate="let data of 'content'">
     <app-legal-entity-history
       #historyComponent
       (closePopupEvent)="hideLegalEntityHistoryPopup()"
       (entitySelectedEvent)="hideLegalEntityHistoryPopup()">
     </app-legal-entity-history>
  </div>
</dx-popup>
